import { render, staticRenderFns } from "./ProjectsSummaryWidget.vue?vue&type=template&id=14b4048a&scoped=true&"
import script from "./ProjectsSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./ProjectsSummaryWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsSummaryWidget.vue?vue&type=style&index=0&id=14b4048a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b4048a",
  null
  
)

export default component.exports